import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalApp } from "../global";
import { Subscription } from "rxjs";
import {DataOnDemandService} from '../../api/services/data-on-demand.service';
import { AdmLayoutService } from '../../api/services/adm-layout.service';

@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.css"],
})
export class NavMenuComponent implements OnInit, OnDestroy {
  isExpanded = false;
  loggedIn = false;
  admin = false;
  supportAdmin = false;
  emailAddress = "";
  impersonating = false;
  reportOnly = false;

  isLoggedInSubscription: Subscription = null;
  isAdminSubscription: Subscription = null;
  isSupportAdminSubscription: Subscription = null;
  currentUserNameSubscription: Subscription = null;
  impersonatingSubscription: Subscription = null;
  reportOnlySubscription: Subscription = null;

  isInteractiveUser: boolean = false;
  isReportExportUser: boolean = false;
  isEmbeddedUser: boolean = false;
  hasReportLayouts: boolean = false;
  hasDodLayouts: boolean = false;

  hasPreFilters: boolean = false;
  hasAiChats: boolean = false;
  // Agent Data Models: shown when at least one of the user's subscriptions has a plan type offering ADM Groups.
  hasAdmAccess: boolean = false;

  constructor(public app: GlobalApp, private router: Router, private dodService: DataOnDemandService, private admLayoutService: AdmLayoutService) {}

  ngOnInit() {
    this.isLoggedInSubscription = this.app.isLoggedIn.subscribe((result) => {
      this.loggedIn = result;
      if (result) {
        this.admLayoutService.admLayoutGetAvailableSubscriptions().subscribe({
          next: (subscriptions) => (this.hasAdmAccess = !!subscriptions && subscriptions.length > 0),
          error: () => (this.hasAdmAccess = false),
        });
      } else {
        this.hasAdmAccess = false;
      }
    });

    this.isAdminSubscription = this.app.isAdmin.subscribe((result) => {
      this.admin = result;
    });

    this.isSupportAdminSubscription = this.app.isSupportAdmin.subscribe((result) => {
      this.supportAdmin = result;
    });

    this.currentUserNameSubscription = this.app.currentUserName.subscribe(
      (result) => {
        this.emailAddress = result;
      }
    );

    this.impersonatingSubscription = this.app.isImpersonating.subscribe((result) => {
      this.impersonating = result;
    });

    this.reportOnlySubscription = this.app.userState.subscribe((userState) => {
      this.reportOnly = userState.reportOnly;

      this.isInteractiveUser = userState.isInteractiveUser;
      this.isReportExportUser = userState.isReportExportUser;
      this.isEmbeddedUser = userState.isEmbeddedUser;

      this.hasAiChats = userState.hasAiChats;

      userState.interactives.forEach(interactive => {
        if (!this.hasReportLayouts) {
          this.hasReportLayouts = interactive.allowPrintOnDemand;
        }
      })

      for (let interact of userState.interactives) {
        if (interact.canPreFilter) {
          this.hasPreFilters = true;
          break;
        }
      }
    });

    this.dodService.dataOnDemandGetUserAvailableDodEndPoints().subscribe(dodEndPoints => {
      if (dodEndPoints && dodEndPoints.length > 0) {
        this.hasDodLayouts = true;
      } else {
        this.hasDodLayouts = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();
    }

    if (this.isAdminSubscription) {
      this.isAdminSubscription.unsubscribe();
    }

    if (this.isSupportAdminSubscription) {
      this.isSupportAdminSubscription.unsubscribe();
    }

    if (this.currentUserNameSubscription) {
      this.currentUserNameSubscription.unsubscribe();
    }

    if (this.impersonatingSubscription) {
      this.impersonatingSubscription.unsubscribe();
    }

    if (this.reportOnlySubscription) {
      this.reportOnlySubscription.unsubscribe();
    }
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  exitImpersonation() {
    this.app.stopImpersonation().subscribe(() => {
      this.hasReportLayouts = false;
      this.hasDodLayouts = false;
      this.hasPreFilters = false;
      this.hasAiChats = false;
    });
  }

  logOut() {
    this.app.logOut();

    this.router.navigate(["/"]);
  }
}
